import { ca } from '@cian/analytics';

export const trackBannerShow = () => trackBannerEvent('Show_sopr');
export const trackBannerClick = () => trackBannerEvent('Click_sopr');

function trackBannerEvent(action: 'Show_sopr' | 'Click_sopr') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action,
    label: 'independent_banner',
  });
}
